import { CommonModule } from '@angular/common'
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  ViewChild,
} from '@angular/core'
import { FormControl } from '@angular/forms'
import { css } from '@codemirror/lang-css'
import { EditorState } from '@codemirror/state'
import { oneDark } from '@codemirror/theme-one-dark'
import { basicSetup, EditorView } from 'codemirror'

@Component({
  selector: 'gb-presenter-custom-css',
  imports: [CommonModule],
  templateUrl: './gb-presenter-custom-css.component.html',
  styleUrl: './gb-presenter-custom-css.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class GbPresenterCustomCssComponent implements AfterViewInit, OnDestroy {
  @ViewChild('cssEditor') cssEditor!: ElementRef

  @Input() customCssControl: FormControl<string> = new FormControl('', { nonNullable: true })

  private editorView: EditorView | null = null

  ngAfterViewInit(): void {
    this.initCssEditor()
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['customCssControl']) {
      this.syncEditorFromControl()
    }
  }

  ngOnDestroy(): void {
    this.editorView?.destroy()
  }

  private initCssEditor(): void {
    const myEditorElement = this.cssEditor.nativeElement
    const listener = EditorView.updateListener.of((update) => {
      if (update.docChanged) {
        const nextValue = update.state.doc.toString()
        if (nextValue !== this.customCssControl?.value) {
          this.customCssControl?.setValue(nextValue)
        }
      }
    })

    let state!: EditorState

    try {
      state = EditorState.create({
        doc: this.customCssControl?.value || '',
        extensions: [basicSetup, css(), oneDark, listener, EditorView.lineWrapping],
      })
    } catch (e) {
      console.error(e)
    }

    this.editorView = new EditorView({
      state,
      parent: myEditorElement,
      extensions: [basicSetup, css(), oneDark, listener],
    })
  }

  private syncEditorFromControl(): void {
    if (!this.editorView) {
      return
    }

    const nextValue = this.customCssControl?.value || ''
    const currentValue = this.editorView.state.doc.toString()
    if (nextValue === currentValue) {
      return
    }

    this.editorView.dispatch({
      changes: {
        from: 0,
        to: this.editorView.state.doc.length,
        insert: nextValue,
      },
    })
  }
}
